import React from "react";

import { UVTable } from "@learningblocks/storybook-components";
import { getActualGel } from "@learningblocks/exp-components/lib/ResultsComparisonGel/commonFunctions"

export function DummyGelTable(props){
  return (
    <UVTable
    >
      {getActualGel(
        props.gelExamined,
        props.gelOrientation,
        props.actualData,
        props.level,
        props.interactionProps
      )}
    </UVTable>
  )
}
